<template>
<div id="applogin" v-cloak>

    <b-container>

        <b-form @submit="onSubmit" class="form-signin">

            <div class="text-center">
                <b-img :src="require('../assets/logoappcral.png')" fluid/>
            </div>

            <h3 class="form-signin-heading">{{'Effettua l\'accesso'}}</h3>

            <b-form-input id="account" type="text" v-model="form.account" required autofocus placeholder="N° Socio"></b-form-input>

            <b-form-input id="password" type="password" v-model="form.password" required placeholder="Password"></b-form-input>

<!--             <b-form-checkbox id="savec" v-model="status" value="S" unchecked-value="N">
                {{'Ricorda credenziali'}}
            </b-form-checkbox> -->
            <b-alert :show="showerror" variant="danger">{{ error }}</b-alert>
            <b-button type="submit" :block=true size="lg" variant="primary">{{'Accedi'}}</b-button>


        </b-form>

    </b-container>
</div>
</template>

<script>
 import {
     NAMESPACE
 } from '../config.js'

export default {
    name: 'applogin',
    /*   data () {
        return {
          msg: 'Welcome to Your Vue.js App'
        }
      } */
    data: function () {

        //var mem = localStorage.getItem('check') || 'N'; //l'or fa la coalesce

        return {
            form: {
                // email: ((mem === 'S') ? localStorage.getItem('email') || '' : ''),
                // password: ((mem === 'S') ? localStorage.getItem('password') || '' : '')
                account: '',
                password: '',
            },
            //status: mem,
            error: '',
            showerror: false
        };
    },
    methods: {

        onSubmit(evt) {
            evt.preventDefault();

            //this.form.language = this.$i18n.locale;

            login(JSON.stringify(this.form), this);

        }

    },
    created: function () {
        //if(typeof localStorage.getItem('language') !== 'undefined'){
            //this.$i18n.locale = localStorage.getItem('language') || this.$i18n.locale
        //}
    }
}

function login(json, applogin) {

    //console.log("NAMESPACE: " + NAMESPACE);

    applogin.axios.post(NAMESPACE + 'rest/login', json, {
            headers: {
                'Content-Type': 'application/json',
                //'Accept-Language': applogin.$i18n.locale
            }
        })
        .then(response => {
            // JSON responses are automatically parsed.
            try {

                if (!response.data.error) {

                    var res = response.data.message;

                    //token = btoa(res.account) + "." + res.password;

                    var token = res.token;

                    localStorage.setItem('token', token);
                    localStorage.setItem('account', res.account);
                    localStorage.setItem('nome', res.nome);
                    localStorage.setItem('cognome', res.cognome);
                    localStorage.setItem('email', res.email);
                    localStorage.setItem('idsocio', res.id);
                    localStorage.setItem('vismenu', res.vismenu);
                    localStorage.setItem('viscategoria', res.viscategoria);
                    localStorage.setItem('appname', res.appname);
                    //localStorage.setItem('language', applogin.$i18n.locale);

                    // if (applogin.status == 'S') {
                    //     localStorage.setItem('check', applogin.status);
                    //     localStorage.setItem('password', applogin.form.password);
                    //     //localStorage.setItem('language', applogin.$i18n.locale);
                    // }
                    //window.location.href = "dashboard";

                    //console.log("Router to /app");

                    applogin.$router.push('/app');

                } else {
                    throw new Error(response.data.message);
                }

            } catch (e) {
                applogin.showerror = true;
                applogin.error = 'Errore: ' + e.message;
            }

        })
        .catch(e => {
            //console.log (e);
            applogin.showerror = true;
            applogin.error = 'Errore: ' + (typeof e.response === 'undefined' ? 'Errore interno API' : (e.response.data.message instanceof Object ? 'Errore interno API' : e.response.data.message));
        });

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {
    padding-top: 40px;
    padding-bottom: 40px;
    background-color: #eee;
}

.form-signin {
    max-width: 330px;
    padding: 15px;
    margin: 0 auto;
}

.form-signin .form-signin-heading,
.form-signin .checkbox {
    margin-bottom: 10px;
}

.form-signin .checkbox {
    font-weight: 400;
}

.form-signin .form-control {
    position: relative;
    box-sizing: border-box;
    height: auto;
    padding: 10px;
    font-size: 16px;
}

.form-signin .form-control:focus {
    z-index: 2;
}

.form-signin input[type="email"] {
    margin-bottom: -1px;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
}

.form-signin input[type="password"] {
    margin-bottom: 10px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}
</style>
